module.exports = __webpack_public_path__ + "media/images/home/faq_answer_icon-423403f533b2a86163d2ae7880e3357c.svg";